import React from "react";
import { truncateDecimals } from "./BenefitDetailTable/OtherBenefit";
import {
  overviewItem,
  itemLabel,
  itemValue,
  policyDetails,
  subTitle,
} from "../Shared/Styles";

  // Date Format function
export const formatDate =(date) => {
  var d = new Date(date),
    day = "" + d.getDate(),
    month = "" + (d.getMonth() + 1),
    year = d.getFullYear();

  if (day.length < 2) day = "0" + day;
  if (month.length < 2) month = "0" + month;

  return [day, month, year].join("/");
}

export default function ProductDetails(props) {
  
  var isBTLife = props.policyOrigin !== undefined && props.policyOrigin === "TLIS";
  var isAsteron = ((props.policyOrigin!== undefined && props.policyOrigin === "ASTERON") || (props.policyOrigin!== undefined && props.policyOrigin!== undefined && props.policyOrigin === "Suncorp"));    

  if (props.productDetails !== undefined) {
    return (
      <div>
        <h3 style={subTitle}>POLICY DETAILS</h3>

        <div style={policyDetails}>
          <div style={overviewItem}>
            <span style={itemLabel}>{isBTLife ? 'Product Suite/Name': 'Product'}</span>
            <span style={itemValue}>{props.productDetails[0].productName}</span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Policy Ownership</span>
            <span style={itemValue}>{props.productDetails[0].policyOwner}</span>
          </div>

          {isBTLife &&
          <div style={overviewItem}>
            <span style={itemLabel}>Risk Commenced Date</span>
            <span style={itemValue}>{props.productDetails[0].commencementDate === null ? "": formatDate(props.productDetails[0].commencementDate)}</span>
          </div>
          }

          <div style={overviewItem}>
            <span style={itemLabel}>Payment Frequency</span>
            <span style={itemValue}>
              {props.productDetails[0].payFrequency}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Total Instalment Premium</span>
            <span style={itemValue}>
              {truncateDecimals(props.productDetails[0].sumInstallmentPremium, 2).toLocaleString("en-US", {style: 'currency', currency: 'USD'})}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Total Annual Premium</span>
            <span style={itemValue}>
              {truncateDecimals(props.productDetails[0].sumAnnualPremium, 2).toLocaleString("en-US", {style: 'currency', currency: 'USD'})}
            </span>
          </div>

          {isBTLife &&
          <>
            <div style={overviewItem}>
              <span style={itemLabel}>Annual Policy Fee</span>
              <span style={itemValue}>${props.productDetails[0].annualPolicyFee} </span>
            </div>
            
            <div style={overviewItem}>
              <span style={itemLabel}>Annual Stamp Duty</span>
              <span style={itemValue}>${props.productDetails[0].sumAnnualStampDuty}</span>
            </div>
          </>
          }

          {isAsteron &&
          <>
            <div style={overviewItem}>
              <span style={itemLabel}>Annual Policy Fee</span>
              <span style={itemValue}>${props.productDetails[0].annualPolicyFee} </span>
            </div>
          </>
          }

          <div style={overviewItem}>
            <span style={itemLabel}>Next Bill Date</span>
            <span style={itemValue}>{props.productDetails[0].nextBillDate === null ? "": formatDate(props.productDetails[0].nextBillDate)}</span>
          </div>

          {isAsteron && 
          <>
            <div style={overviewItem}>
              <span style={itemLabel}>Paid To Date</span>
              <span style={itemValue}>{props.productDetails[0].datePaid === null ? "": formatDate(props.productDetails[0].datePaid)}</span>
            </div>
          </>          
          }

          {!isBTLife && !isAsteron  &&
          <div style={overviewItem}>
            <span style={itemLabel}>Arrears Amount</span>
            <span style={itemValue}>
              {truncateDecimals(props.productDetails[0].policyArrearAmount, 2).toLocaleString("en-US", {style: 'currency', currency: 'USD'})}
            </span>
          </div>
          }

          {isBTLife && 
          <>
            <div style={overviewItem}>
              <span style={itemLabel}>Date Paid To</span>
              <span style={itemValue}>{props.productDetails[0].datePaid === null ? "": formatDate(props.productDetails[0].datePaid)}</span>
            </div>
          
            <div style={overviewItem}>
              <span style={itemLabel}>Renewal Date</span>
              <span style={itemValue}>{props.productDetails[0].anniversaryDate === null ? "" : formatDate(props.productDetails[0].anniversaryDate)}</span>
            </div>
          </>          
          }

        </div>

        {isBTLife &&
        <div style={{marginLeft: "40px",}}>
        <p style={{
          textAlign: "justify",
          paddingTop: "30px"
        }}>          
          <p>
            Note: Your total annual premium is inclusive of any applicable policy fee and stamp duty.
          </p>
          <p>
          Your policy may have other linked benefits and options which are not listed in this document and may be impacted if your policy is altered or cancelled. For full details, please refer to your Product Disclosure Document and most recent policy schedule. 
          </p>
        </p>
        </div>
        }
      </div>
    );
  }
}
